exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host{display:flex;flex-direction:column}:host .avertissement-header{font-size:17px;font-weight:600;line-height:2rem}:host .avertissement-header,:host .explication{font-family:Open Sans}:host strong{font-size:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/depot-requete/steps/juridiction/type-acte-attaque-section/type-acte-attaque-avertissement/type-acte-attaque-avertissement.component.scss
// module id = 669
// module chunks = 0